import { BatchAddContactsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useBatchAddContacts() {
  const [fetching, setFetching] = useState(false);

  async function batchAddContacts(params: BatchAddContactsRequest) {
    try {
      setFetching(true);
      const res = await api.batchAddContacts(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, batchAddContacts };
}
